define('app/views/google_map_view',['app/setup', 'async'], function(takhfifan) {

  takhfifan.GoogleMapView = Backbone.View.extend({

    initialize: function() {
      takhfifan.gmap = this;
      var _this = this;
      $('.view-map-btn').on('click', function() {
        _this.showMap();
      });
    },

    loadMap: function() {
      this.render();
    },

    render: function() {
      var options = this.configOptions();
      var lat = options.position[0];
      var lng = options.position[1];
      $('.map-view-placeholder').fadeOut();
      var map;
      map = new L.Map('tmap');
      var osmUrl='https://{s}.maps.takhfifan.com/hot/{z}/{x}/{y}.png';
      var osmAttrib='';
      var osm = new L.TileLayer(osmUrl, {minZoom: 0, maxZoom: 16, attribution: osmAttrib});
      map.setView(new L.LatLng(lat, lng), 14);
      map.addLayer(osm);
      L.marker([lat, lng]).addTo(map);
    },

    configOptions: function() {
      return {
        position: this.$el.data('location').split(','),
        vendor: this.$el.data('vendor')
      }
    },

    showMap: function() {
      if($('.map-view-placeholder').length){
        $('.map-view-placeholder').fadeOut();
        this.loadMap();
      }
    }
  });
});

